<body>
    <app-nav-menu></app-nav-menu>
    <div class="container">
        <router-outlet>
            <!-- <spinner type="fullScreen"></spinner>  -->
        </router-outlet>
    </div>
</body>


